import { useState, useEffect } from 'react';
import { getReportExportLogs } from '../../api';

function formatDateTime(dt) {
  if (!dt) return '';
  const d = new Date(dt);
  return d.toLocaleDateString('en-GB') + ' ' + d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

export default function ExportLogTab({ report }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getReportExportLogs(report.id)
      .then(setLogs)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [report.id]);

  if (loading) return <p>Loading export logs...</p>;

  return (
    <div>
      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              <th>Downloaded By</th>
              <th>Email</th>
              <th>Version</th>
              <th>Rev</th>
              <th>Report Last Edited</th>
              <th>Downloaded At</th>
              <th>IP Address</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td>{log.downloadedByName}</td>
                <td>{log.downloadedByEmail}</td>
                <td>{log.versionNumber || '-'}</td>
                <td>{log.systemVersion || '-'}</td>
                <td>{formatDateTime(log.reportUpdatedAt)}</td>
                <td>{formatDateTime(log.downloadedAt)}</td>
                <td>{log.ipAddress || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {logs.length === 0 && <p style={{ color: '#888' }}>No exports recorded yet.</p>}
    </div>
  );
}
